import { format, startOfMonth, endOfMonth, eachDayOfInterval, getDay, addMonths, subMonths } from 'date-fns';
import { ko } from 'date-fns/locale';

/**
 * 특정 월의 캘린더 그리드 생성 (일요일 시작)
 * @param year 연도
 * @param month 월 (1-12)
 * @returns 날짜 배열 (앞뒤 빈 칸 포함)
 */
export const generateCalendarGrid = (year: number, month: number): (Date | null)[] => {
  const firstDay = startOfMonth(new Date(year, month - 1));
  const lastDay = endOfMonth(new Date(year, month - 1));
  
  // 해당 월의 모든 날짜
  const daysInMonth = eachDayOfInterval({ start: firstDay, end: lastDay });
  
  // 첫 날의 요일 (0: 일요일, 1: 월요일, ...)
  const firstDayOfWeek = getDay(firstDay);
  
  // 앞쪽 빈 칸
  const leadingEmptyDays = Array(firstDayOfWeek).fill(null);
  
  // 뒤쪽 빈 칸 (6줄 고정)
  const totalCells = 42; // 7일 × 6주
  const trailingEmptyDays = Array(totalCells - leadingEmptyDays.length - daysInMonth.length).fill(null);
  
  return [...leadingEmptyDays, ...daysInMonth, ...trailingEmptyDays];
};

/**
 * 월 이름 포맷 (YYYY년 M월)
 */
export const formatMonthYear = (year: number, month: number): string => {
  return `${year}년 ${month}월`;
};

/**
 * 날짜 포맷 (M월 D일)
 */
export const formatDate = (date: Date): string => {
  return format(date, 'M월 d일', { locale: ko });
};

/**
 * 이전/다음 월 계산
 */
export const getPreviousMonth = (year: number, month: number): { year: number; month: number } => {
  const date = subMonths(new Date(year, month - 1), 1);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
  };
};

export const getNextMonth = (year: number, month: number): { year: number; month: number } => {
  const date = addMonths(new Date(year, month - 1), 1);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
  };
};
